module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "file_011"
    }
  }, [_vm._v("LEON “JAKE” SWIRBUL AND HIS BUSINESS associate, Leroy Grumman, slowly picked their way along the edge of a muddy Long Island roadway. They were looking for metal.")])]), _c('a', {
    attrs: {
      "id": "file_011"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The metal was for the shop. Their young business was struggling, so they used practically anything they could find. A hammer that slipped off the bumper of a delivery truck became a tool used every day. A solid piece of metal strapping they had liberated now supported a set of new shelves. Something as simple as a shiny silver bolt or washer was scooped up, examined, and slipped into a pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a good day, the scavenging pair might find some high-grade hunk of alloy that could be made into something else. Though they didn’t mention such things to their customers, a few fragments of every airplane float and truck body that their company produced were fabricated from hand-me-downs. Even portions of their new fighter plane had come straight out of the ditch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With luck on their side, there was no telling what they might find. But for the past few years, it seemed, luck eluded them. As a result, the duo kept a wary eye on the traffic—each half expecting his life to end under the wheels of a wayward freight box or carryall that had strayed too far over to the shoulder of the road.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b5c926b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_011.vue
// module id = 84
// module chunks = 0